import { Vehicle } from 'core/models/vehicle';
import { VehicleConfiguration } from 'core/models/vehicleConfiguration';
import { useCallback, useEffect, useState } from 'react';
import { useVehicleConfigurationRepository } from './useVehicleConfigurationRepository';
import { cancellable } from './utility/cancellable';

export function useVehicleConfiguration(vehicleId: Vehicle.Id) {
    const repos = useVehicleConfigurationRepository();

    const [config, setConfig] = useState<VehicleConfiguration>();

    useEffect(() => {
        const target = vehicleId;

        return cancellable(async isCancel => {
            const config = await repos.getVehicleConfiguration(target);
            if (isCancel()) return;
            setConfig(config);
        });
    }, [vehicleId, setConfig, repos]);

    useEffect(() => {
        const target = vehicleId;

        const listener = (config: VehicleConfiguration | undefined) => {
            setConfig(config);
        };

        repos.addVehicleConfigurationListener(target, listener);

        return () => repos.removeVehicleConfigurationListener(target, listener);
    }, [vehicleId, setConfig, repos]);

    const setVehicleConfig = useCallback(async (config: Partial<VehicleConfiguration>) => {
        await repos.setVehicleConfiguration(vehicleId, config);
    }, [vehicleId, repos]);

    return [config, setVehicleConfig] as const;
}
